/* eslint-disable react-refresh/only-export-components */
import { type ReactNode, createContext, useContext, useState } from 'react';

interface HeaderBreadcrumbContextValue {
  /** Extra breadcrumb label shown after tenant ➤ app (e.g. environment name) */
  contextLabel: string | null;
  /** Set the extra label — call with null to clear */
  setContextLabel: (label: string | null) => void;
}

const HeaderBreadcrumbContext = createContext<HeaderBreadcrumbContextValue>({
  contextLabel: null,
  setContextLabel: () => {},
});

export const HeaderBreadcrumbProvider = ({ children }: { children: ReactNode }) => {
  const [contextLabel, setContextLabel] = useState<string | null>(null);
  return (
    <HeaderBreadcrumbContext.Provider value={{ contextLabel, setContextLabel }}>
      {children}
    </HeaderBreadcrumbContext.Provider>
  );
};

/** Read/write the header breadcrumb context label */
export const useHeaderBreadcrumb = () => useContext(HeaderBreadcrumbContext);
